import * as React from "react"
import { Box, Grid, Typography } from "@mui/material"

import { ImageSkuBlock, MoreLessInfo, MultimediaRow, PlaceholderVideoImg } from "@components"
import { multimediaCarouselImages, multimediaCarouselVideos } from "@signals"


const ImagesBlockContainer = ({ img }) => <ImageSkuBlock hideName imageURL={img} isClickable={false} contentProps={{ sx : {width: 75, height: 75 }}}/>

export default function AdminNewListedDetailsDrawerContentTabDescription(props) {
    const { images, videos, giftImages, description, hasRichContent, richContentImages, richContentVideos, richContentText } = props

    return <Box display="flex" flexDirection="column" gap={2}>

        <MultimediaRow
            title="Images:"
            multimedia={images}
            handleClick={value => multimediaCarouselImages.value = value}
            Container={({ item }) => <ImagesBlockContainer img={item} sx={{ width: 150, height: 150 }}/>}
        />

        <MultimediaRow
            title="Videos:"
            multimedia={videos}
            handleClick={value => multimediaCarouselVideos.value = value}
            Container={() => <PlaceholderVideoImg />}
        />

        <MultimediaRow
            title="Gift Images:"
            multimedia={giftImages}
            handleClick={value => multimediaCarouselImages.value = value}
            Container={({ item }) => <ImagesBlockContainer img={item} />}
        />

        <Grid item xs={12}>
            <MoreLessInfo>
                {description}
            </MoreLessInfo>
        </Grid>

        <Grid item xs={12}>
            <Typography variant="subtitle2" >
                Rich Content: { !hasRichContent && "--" }
            </Typography>

            { !!hasRichContent && <MoreLessInfo moreText="Show Rich Content..." lessText="Less Rich Content...">
                <MultimediaRow
                    title="Images:"
                    multimedia={richContentImages}
                    handleClick={value => multimediaCarouselImages.value = value}
                    Container={({ item }) => <ImagesBlockContainer img={item} />}
                />

                <MultimediaRow
                    title="Videos:"
                    multimedia={richContentVideos}
                    handleClick={value => multimediaCarouselVideos.value = value}
                    Container={() => <PlaceholderVideoImg />}
                />

                <Typography variant="subtitle2" >
                    Content:
                </Typography>

                <Typography>
                    {richContentText}
                </Typography>
            </MoreLessInfo> }
        </Grid>
    </Box>
}